import { useEffect, useState } from 'react';
import {
    Button,
    Form,
    Input,
    Card,
    message,
} from 'antd';
import ContactApi from '../api/contact';

const Contact = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await ContactApi.getAll();
            form.setFieldsValue(res.data);
        } catch {
            message.error('Ошибка при загрузке данных');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSubmit = async (values) => {
        try {
            await ContactApi.update(values);
            message.success('Контактная информация обновлена');
        } catch {
            message.error('Ошибка при сохранении');
        }
    };

    return (
        <div>
            <h2 className="text-xl font-semibold mb-4">Контактная информация</h2>

            <Card>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    initialValues={{}}
                >
                    <Form.Item name="location" label="Локация">
                        <Input />
                    </Form.Item>
                    <Form.Item name="email" label="E-mail">
                        <Input />
                    </Form.Item>
                    <Form.Item name="phone" label="Телефон">
                        <Input />
                    </Form.Item>

                    <Form.Item name="telegram" label="Telegram">
                        <Input />
                    </Form.Item>
                    <Form.Item name="instagram" label="Instagram">
                        <Input />
                    </Form.Item>
                    <Form.Item name="facebook" label="Facebook">
                        <Input />
                    </Form.Item>
                    <Form.Item name="twitter" label="Twitter">
                        <Input />
                    </Form.Item>
                    <Form.Item name="linkedin" label="LinkedIn">
                        <Input />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" loading={loading}>
                        Сохранить
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default Contact;
